(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-header')) {
    customElements.define('custom-header', class CustomHeader extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.wrapper = this.querySelector('.ch-wrapper');
        this.initStickyHeader();
        this.initSearch();
        this.initDrawer();
        this.initDropdownClose();
      }

      initStickyHeader() {
        if (!this.wrapper) return;
        var stickyMode = this.wrapper.getAttribute('data-sticky') || 'none';
        if (stickyMode === 'none') return;
        
        var lastScrollY = window.scrollY;
        var ticking = false;
        var isSticky = false;
        var isHidden = false;
        var headerHeight = this.wrapper.offsetHeight;

        window.addEventListener('resize', () => {
          headerHeight = this.wrapper.offsetHeight;
        });

        const onScroll = () => {
          var currentY = window.scrollY;
          if (!ticking) {
            requestAnimationFrame(() => {
              if (currentY > 60) {
                if (!isSticky) {
                  this.wrapper.classList.add('ch-is-sticky');
                  isSticky = true;
                }
              } else if (isSticky) {
                this.wrapper.classList.remove('ch-is-sticky');
                isSticky = false;
              }

              if (stickyMode === 'on-scroll-up') {
                var scrollingDown = currentY > lastScrollY;
                if (scrollingDown && currentY > headerHeight && !isHidden) {
                  this.wrapper.classList.add('ch-header-hidden');
                  isHidden = true;
                } else if (!scrollingDown && isHidden) {
                  this.wrapper.classList.remove('ch-header-hidden');
                  isHidden = false;
                }
              }

              lastScrollY = currentY;
              ticking = false;
            });
            ticking = true;
          }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
      }

      initSearch() {
        var toggleBtn = this.querySelector('.ch-search-toggle');
        var modal = this.querySelector('.ch-search-modal');
        var closeBtn = this.querySelector('.ch-search-close');
        var overlay = this.querySelector('.ch-search-overlay');
        var input = this.querySelector('.ch-search-input');
        if (!toggleBtn || !modal) return;

        const openModal = () => {
          modal.setAttribute('aria-hidden', 'false');
          toggleBtn.setAttribute('aria-expanded', 'true');
          if (input) {
            setTimeout(() => input.focus(), 100);
          }
          document.body.style.overflow = 'hidden';
        };

        const closeModal = () => {
          modal.setAttribute('aria-hidden', 'true');
          toggleBtn.setAttribute('aria-expanded', 'false');
          toggleBtn.focus();
          setTimeout(() => {
            if (modal.getAttribute('aria-hidden') === 'true') {
              document.body.style.overflow = '';
            }
          }, 350);
        };

        toggleBtn.addEventListener('click', () => {
          var isOpen = modal.getAttribute('aria-hidden') === 'false';
          if (isOpen) closeModal();
          else openModal();
        });

        if (closeBtn) closeBtn.addEventListener('click', closeModal);

        /* Close when clicking anywhere outside the search panel */
        document.addEventListener('click', (e) => {
          if (modal.getAttribute('aria-hidden') !== 'false') return;
          var panel = modal.querySelector('.ch-search-panel');
          if (panel && panel.contains(e.target)) return;
          if (toggleBtn.contains(e.target)) return;
          closeModal();
        });

        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
        });
      }

      initDrawer() {
        var drawerBtn = this.querySelector('.ch-drawer-toggle');
        var drawer = this.querySelector('.ch-drawer-menu');
        var closeBtn = this.querySelector('.ch-drawer-close');
        var overlay = this.querySelector('.ch-drawer-overlay');
        if (!drawerBtn || !drawer) return;

        const openDrawer = () => {
          drawer.setAttribute('aria-hidden', 'false');
          drawerBtn.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
          var panel = drawer.querySelector('.ch-drawer-panel');
          if (panel) panel.focus();
        };

        const closeDrawer = () => {
          drawer.setAttribute('aria-hidden', 'true');
          drawerBtn.setAttribute('aria-expanded', 'false');
          drawerBtn.focus();
          setTimeout(() => {
            if (drawer.getAttribute('aria-hidden') === 'true') {
              document.body.style.overflow = '';
            }
          }, 350);
        };

        drawerBtn.addEventListener('click', openDrawer);
        if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
        if (overlay) overlay.addEventListener('click', closeDrawer);

        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
        });
      }

      initDropdownClose() {
        const animateClose = (details, focusEl) => {
          if (details.classList.contains('ch-closing')) return;
          details.classList.add('ch-closing');
          const finish = () => {
            if (!details.classList.contains('ch-closing')) return;
            details.classList.remove('ch-closing');
            details.removeAttribute('open');
            if (focusEl) focusEl.focus();
          };
          var panel = details.querySelector('.ch-dropdown, .ch-mega');
          if (panel) {
            panel.addEventListener('animationend', finish, { once: true });
            setTimeout(finish, 300);
          } else {
            finish();
          }
        };

        /* Intercept summary click to animate close */
        this.querySelectorAll('.ch-nav-row details > summary').forEach((summary) => {
          summary.addEventListener('click', (e) => {
            var details = summary.closest('details');
            if (details.hasAttribute('open')) {
              e.preventDefault();
              animateClose(details, summary);
            }
          });
        });

        /* Close when clicking outside */
        document.addEventListener('click', (e) => {
          this.querySelectorAll('.ch-nav-item details[open]').forEach((d) => {
            if (!d.contains(e.target)) {
              animateClose(d);
            }
          });
        });

        /* Close on Escape */
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.querySelectorAll('.ch-nav-item details[open]').forEach((d) => {
              if (d.contains(e.target) || d.matches(':focus-within')) {
                animateClose(d, d.querySelector('summary'));
              }
            });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
